import React, { useState } from "react";
import Modal from "../../../Modal/Modal";
import Divider from "../../../Common/Divider";
import Button from "../../../Buttons/Button";
import MailRecipient from "../../../FormFields/MailFields/MailRecipient";

const SubmitInvoice = ({ onClose, isOpen }) => {
  return (
    <Modal
      title={"CHANGE INVOICE(S) NOTE"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-4xl"
    >
      <div>
        <div className="min-h-[250px]">
          {/* <div>
            <div className="flex items-center gap-4">
              <div className="text-neutral-400 min-w-14">To:</div>
              <div className="w-full">
                <div className="text-end text-primary">Cc Bcc</div>

                <Divider />
              </div>
            </div>
          </div> */}
          <MailRecipient/>

          <div className="mt-4">
            <div className="flex items-center gap-4">
              <div className="text-neutral-400 min-w-14">Subject:</div>
              <div className="w-full">
                Invoices
                <Divider />
              </div>
            </div>
          </div>
          <div className="min-h-[200px] border border-gray-100 mt-2 rounded-sm px-2 py-2">
           <h6>text editor</h6>
          </div>
        </div>
        <div className="mt-2 flex gap-2 items-center">
          <Button
            type="icon"
            size="xs "
            icon={"e911_emergency"}
            variant="text"
            color="black"
          />
          <div className="font-bold body-two">
            Note:
            <span className="body-two font-normal">
              Each invoice will be mailed as seperate email.
            </span>
          </div>
        </div>
        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title="Submit" onClick={() => {}} />
        </div>
      </div>
    </Modal>
  );
};

export default SubmitInvoice;
